<script setup lang="ts">
    // @ts-nocheck
    // nocheck pga att vi har urgamla versioner av allt och TS kaosar

    import KSub from "@/components/forms/subComponents/Sub/KSub.vue";
    import { CommonProps } from "@/components/forms/types";
    import { computed, toRefs } from "vue";

    const props = withDefaults(
        defineProps<{
            validation?: CommonProps["validation"];
            content: string;
            /**
             * Ska fältet visas som required, även fast det inte är satt i valideringen?
             */
            showAsRequired?: boolean;
            errors?: string[];
            /**
             * Storlek på font
             */
            size?: "default" | "large" | "small";
            /**
             * Marginal som läggs på botten av label
             */
            margin?: "default" | "large" | "none";
            /**
             * Font weight
             */
            weight?: "default" | "bold";
            /**
             * Namn på fältet som label tillhör. Används för att sätta prop for på label och göra så att det är
             * klickbart på t.ex checkbox/radio
             */
            inputName?: string;
            /**
             * KSub.vue prop Text som renderas under label
             */
            subText?: string;
            /**
             * KSub.vue prop Ikon som renderas under label
             */
            subIcon?: string;
            /**
             * KSub.vue prop Typ av subtitle
             */
            subType?: string;
            variant?: "default" | "dark" | "blue";
        }>(),
        {
            showAsRequired: false,
            size: "default",
            margin: "default",
            weight: "default",
            variant: "default",
        }
    );

    const { validation, showAsRequired } = toRefs(props);

    const markAsRequired = computed(() => {
        if (showAsRequired?.value) {
            return true;
        }

        if (Array.isArray(validation)) {
            return (validation.value as Array<string[]>).some((validationArray) =>
                validationArray.some((value) => value === "required")
            );
        }

        if (typeof validation?.value === "string") {
            return validation.value.includes("required");
        }

        return false;
    });
</script>

<template>
    <div v-if="content || subText" :class="['k-label', `margin-${margin}`]">
        <label
            :class="['label', size, { error: errors?.length > 0 }, `weight-${weight}`, `variant-${variant}`]"
            :for="inputName"
        >
            {{ `${content}${markAsRequired ? " *" : ""}` }}
        </label>
        <KSub v-if="subText" :text="subText" :icon="subIcon" :type="subType" />
    </div>
</template>

<style scoped lang="scss">
    @import "@/style/form";
    @import "@/style/variables";

    .k-label {
        display: flex;
        flex-direction: column;
        gap: calc($form-row-gap / 3);
        max-width: max-content;

        &.margin-default {
            margin-bottom: $form-label-default-margin-bottom;
        }

        &.margin-small {
            margin-bottom: 0.1rem;
        }

        &.margin-none {
            margin-bottom: 0;
        }

        &.margin-large {
            margin-bottom: $form-label-large-margin-bottom;
        }

        .label {
            color: $form-label-default-color;
            margin-bottom: 0;

            &.error {
                color: $form-label-error-color;
            }

            &.large {
                color: $form-label-large-color;
                font-size: 1.1rem;
            }

            &.small {
                font-size: 0.9rem;
            }

            &.weight-bold {
                font-family: Roboto Medium, sans-serif;
            }

            &.variant-dark {
                color: $color-dark;
            }

            &.variant-blue {
                color: $dialog-information;
            }
        }
    }
</style>
